import { Fragment, type FC } from 'react';
import { Outlet } from 'react-router';

import { AppDrawer } from '#packages/web/navigation/app-drawer';

import { useAuth } from '../hooks/use-auth';
import { useDrawer } from '../hooks/use-drawer';
import { routes } from '../routes';

export const AppLayout: FC = () => {
  const auth = useAuth();
  const drawer = useDrawer();

  return (
    <Fragment>
      {/* RENDER ALWAYS AVAILABLE COMPONENTS HERE */}
      <AppDrawer
        open={drawer.isOpen}
        onClose={drawer.close}
        onSignInClick={auth.signIn}
        onSignOutClick={auth.signOut}
        userProfile={auth.profile}
        routes={{
          auditsList: routes.audit.index,
          userProfile: routes.userProfile.index,
          userSettings: routes.userSettings.index,
        }}
        appVersion={__VERSION__}
      />

      {/* DO NOT ADD ANYTHING BELOW THIS LINE */}
      <Outlet />
    </Fragment>
  );
};
